import { compose } from 'redux';
import { Form } from 'antd';

import SearchBar from './SearchBar';

export default compose(
  Form.create()
)(SearchBar);
